import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { AsyncPipe, NgStyle, TitleCasePipe } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatGridListModule } from '@angular/material/grid-list';
import { MenuModule } from 'primeng/menu';
import { BadgeModule } from 'primeng/badge';
import { RippleModule } from 'primeng/ripple';
import { AvatarModule } from 'primeng/avatar';
import { PanelModule } from 'primeng/panel';
import { AuthFacade } from '@auth/lib/+state/auth.facade';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CoreUiFacade } from '@core/lib/+state/core-ui.facade';
import { Breadcrumb } from 'primeng/breadcrumb';
import { Popover } from 'primeng/popover';

@Component({
  selector: 'app-console-layout',
  imports: [
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    MatMenuModule,
    MatListModule,
    RouterModule,
    MatGridListModule,
    MenuModule,
    BadgeModule,
    RippleModule,
    AvatarModule,
    PanelModule,
    MatTooltipModule,
    Breadcrumb,
    Popover,
    AsyncPipe,
    TitleCasePipe,
    NgStyle,
  ],
  templateUrl: './console-layout.component.html',
  styleUrl: './console-layout.component.css',
})
export class ConsoleLayoutComponent implements OnInit, OnDestroy {
  activatedRoute = inject(ActivatedRoute);
  authFacade = inject(AuthFacade);
  router = inject(Router);
  coreUi = inject(CoreUiFacade);
  darkMode = signal(false);
  url = toSignal(this.activatedRoute.url);
  sidebarOpen = signal(true);
  pageTitle = toSignal(this.coreUi.pageTitle$);
  breadcrumbs = toSignal(this.coreUi.breadcrumbs$);
  items = [
    {
      items: [
        {
          label: 'Home',
          path: '/console',
          icon: 'home',
        },
        {
          label: 'Preservation & Digitization',
          path: '/console/digitization',
          icon: 'scan',
        },
      ],
    },
    { separator: true },
    {
      items: [
        {
          label: 'Settings',
          path: '/settings',
          icon: 'settings',
        },
      ],
    },
  ];
  user$ = this.authFacade.user$;
  permissions$ = this.authFacade.permissions$;

  ngOnInit() {
    this.authFacade.getUser();
    this.coreUi.setPageTitle('Console');
    this.coreUi.addBreadcrumb({
      label: 'Home',
      url: '/console',
    });

    if (localStorage.getItem('sidebarOpen')) {
      this.sidebarOpen.set(localStorage.getItem('sidebarOpen') === 'true');
    }
  }

  ngOnDestroy() {
    this.coreUi.removeBreadcrumb({
      label: 'Home',
      url: '/console',
    });
  }

  signOut() {
    this.authFacade.signOut();
  }

  toggleSideBar() {
    localStorage.setItem('sidebarOpen', !this.sidebarOpen() + '');
    this.sidebarOpen.set(!this.sidebarOpen());
  }

  toggleColourTheme() {
    console.log(this.router.url);
    this.darkMode.set(!this.darkMode());
    document.body.classList.toggle('dark');
  }
}
